<template>
    <b-modal :active="!!customer" @close="$emit('close')" aria-modal :width="500" :can-cancel="!deleting">
        <div class="modal-card" style="width: auto">
            <b-loading :active="loading || deleting" :is-full-page="false"></b-loading>

            <header class="modal-card-head">
                <p class="modal-card-title">Klant verwijderen</p>
            </header>

            <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                <!-- Checking eligibility -->
                <div v-if="loading">
                    <p>Bezig met controleren...</p>
                </div>

                <!-- Cannot delete: active contracts -->
                <div v-else-if="reason === 'active-contracts'">
                    <p class="has-text-danger"><strong>Verwijderen niet mogelijk</strong></p>
                    <p>Deze klant heeft nog een of meer actieve contracten. Beëindig de contracten eerst voordat de klant verwijderd kan worden.</p>
                </div>

                <!-- Cannot delete: open payments -->
                <div v-else-if="reason === 'open-payments'">
                    <p class="has-text-danger"><strong>Verwijderen niet mogelijk</strong></p>
                    <p>Deze klant heeft nog openstaande betalingen. Verwerk eerst alle openstaande betalingen voordat de klant verwijderd kan worden.</p>
                </div>

                <!-- Can delete -->
                <div v-else-if="canDelete">
                    <p><strong>Weet je zeker dat je {{ customer.firstname }} {{ customer.lastname }} wilt verwijderen?</strong></p>
                    <p>Deze actie kan niet ongedaan worden gemaakt.</p>
                </div>
            </section>

            <footer class="modal-card-foot">
                <b-button @click="$emit('close')" :disabled="deleting">Annuleren</b-button>
                <b-button
                    v-if="canDelete"
                    type="is-danger"
                    :loading="deleting"
                    @click="confirmDelete"
                >
                    Verwijderen
                </b-button>
            </footer>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'CustomersDeleteModal',

    props: {
        customer: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            loading: false,
            deleting: false,
            canDelete: false,
            reason: null
        }
    },

    watch: {
        customer(newVal) {
            if (newVal) {
                this.checkEligibility()
            } else {
                this.canDelete = false
                this.reason = null
            }
        }
    },

    methods: {
        checkEligibility() {
            this.loading = true
            this.canDelete = false
            this.reason = null

            axios.get(`/api/customer/${this.customer.id}/delete-eligibility`, {
                headers: { 'Authorization': 'bearer ' + this.$store.state.authToken }
            }).then((response) => {
                this.canDelete = response.data.canDelete
                this.reason = response.data.reason || null
            }).catch(() => {
                this.reason = 'error'
            }).then(() => {
                this.loading = false
            })
        },

        confirmDelete() {
            this.deleting = true

            axios.delete(`/api/customer/${this.customer.id}`, {
                headers: { 'Authorization': 'bearer ' + this.$store.state.authToken }
            }).then(() => {
                this.$buefy.toast.open({ message: 'Klant verwijderd', type: 'is-success' })
                this.$emit('deleted', this.customer.id)
                this.$emit('close')
            }).catch(() => {
                this.$buefy.toast.open({ message: 'Verwijderen mislukt', type: 'is-danger' })
            }).then(() => {
                this.deleting = false
            })
        }
    }
}
</script>
